"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DustStorm = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Resources_1 = require("../../Resources");
var Tags_1 = require("../Tags");
var Options_1 = require("../Options");
var DustStorm = (function (_super) {
    __extends(DustStorm, _super);
    function DustStorm() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.DUST_STORM,
            cost: 17,
            tags: [Tags_1.Tags.MARS],
            tr: { temperature: 2 },
            metadata: {
                cardNumber: 'Pf08',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.minus().energy(1, { all: Options_1.all }).asterix();
                    b.br;
                    b.temperature(2);
                }),
                description: 'Every player loses all energy. Raise the temperature 2 steps.',
            },
        }) || this;
    }
    DustStorm.prototype.play = function (player) {
        player.game.getPlayers().forEach(function (p) { return p.addResource(Resources_1.Resources.ENERGY, -p.energy, { log: true }); });
        player.game.increaseTemperature(player, 2);
        return undefined;
    };
    return DustStorm;
}(Card_1.Card));
exports.DustStorm = DustStorm;
